import emojione from 'emojione';

const emojiUnicode = function () {
  return function (str) {
    return emojione.shortnameToUnicode(str);
  };
};

export default emojiUnicode;
